import { colors, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const tooltip = css`
  width: 215px;

  > :last-child {
    margin-top: 10px;
  }
`;

export const listItemWrapper = css`
  margin: 0;
  padding: 0;
`;

export const dividerWrapper = css`
  && {
    margin: 10px 0 20px;
  }
`;

export const incompletedBanner = css`
  padding: 15px 20px 20px;
  border-radius: 5px;
  background-color: ${colors.primary.a2};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const bannerText = css`
  color: ${colors.gray[10]};
`;

export const learnMoreButton = css`
  && {
    color: ${colors.primary.default};
  }
  font-weight: ${fontWeight.bold};

  :visited {
    color: ${colors.primary[9]};
  }

  :hover {
    color: ${colors.primary[10]};
  }
`;

export const disable = css`
  opacity: 0.5;
`;

export const cardContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px 15px;
  border: 1px solid ${colors.gray[6]};
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
`;

export const onlineIcon = css`
  display: flex;
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  color: ${colors.primary[9]};
`;

export const listItem = css`
  display: flex;
  flex-direction: column;
`;
